module.exports = __webpack_public_path__ + "img/happytablet_info2.b756e12f.jpg";